module.exports = __webpack_public_path__ + "static/media/alex.73c32ad0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/alex.jpg
// module id = 975
// module chunks = 0